import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpImage = function (_NebulaModuleBase) {
    _inherits(UpImage, _NebulaModuleBase);

    function UpImage() {
        _classCallCheck(this, UpImage);

        return _possibleConstructorReturn(this, (UpImage.__proto__ || Object.getPrototypeOf(UpImage)).apply(this, arguments));
    }

    _createClass(UpImage, [{
        key: 'imagePicker',
        value: function imagePicker(params) {
            return this.generatePromiseByFunctionWithParams('imagePickerForAlbumPlugin', params);
        }
    }, {
        key: 'openCamera',
        value: function openCamera(params) {
            return this.generatePromiseByFunctionWithParams('openCameraForAlbumPlugin', params);
        }
    }, {
        key: 'saveImages',
        value: function saveImages(params) {
            return this.generatePromiseByFunctionWithParams('saveImagesForAlbumPlugin', params);
        }
    }, {
        key: 'fileToBase64',
        value: function fileToBase64(params) {
            return this.generatePromiseByFunctionWithParams('fileToBase64ForAlbumPlugin', params);
        }
    }]);

    return UpImage;
}(NebulaModuleBase);